import ENV from '../constants/Env';
import { useStyles } from '../components/rides/rideFormStyles';
import MainLayout from '../components/layout/MainLayout';

export default function StopImpersonation() {
  const classes = useStyles();

  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="Portal Stop Impersonation"
        src={`${ENV.portalUrl}/stop-impersonation?embeddedInDashboard=true`}
        className={classes.iframe}
      />
    </MainLayout>
  );
}
